// import { useMemo } from "react";
import { useMemo, useState } from "react";
import cn from "classnames";
import { OrderQueryColumn, SeaOrderQuery } from "entities/SeaSavedCard";
import { useTranslation } from "shared/localization/localization";
import { OrderIcon } from "shared/ui/Icons";
import stylesFilter from "../../Filter.module.scss";
import styles from "./FilterOrder.module.scss";

import { useFilterContext } from "../../context/Filter.context";
import { FilterRadioButton } from "../FilterRadioButton";

type FilterOrderProps = {
  onChange: (data: SeaOrderQuery[]) => void;
};

export const FilterOrder: RFC<FilterOrderProps> = ({ onChange }) => {
  const { t } = useTranslation();
  const { innerFilterState } = useFilterContext();
  const [asc, setAsc] = useState<boolean>(innerFilterState.filter.order[0]?.asc ?? false);

  const orderColumn = useMemo(() => {
    if (!innerFilterState.filter.order.length) return;
    return innerFilterState.filter.order[0].column;
  }, [innerFilterState.filter.order]);

  const onChangeHandler = (event: React.ChangeEvent<HTMLInputElement>) => {
    onChange([{ column: event.currentTarget.value as OrderQueryColumn, asc }]);
  };

  const resolveChecked = (value: OrderQueryColumn) => {
    if (!orderColumn) return false;
    return value === orderColumn;
  };

  return (
    <div className={styles.order}>
      <div className={styles.title}>
        <div className={cn(stylesFilter.propTitle, styles.titleOrder)}>{t("Sort by")}</div>
        <div>
          <OrderIcon
            className={cn(styles.icon, { [styles.isAsc]: asc })}
            onClick={() => {
              const newAsc = !asc;
              setAsc(newAsc);
              if (orderColumn) {
                onChange([{ column: orderColumn, asc: newAsc }]);
              }
            }}
          />
        </div>
      </div>
      <div className={styles.radioBtn}>
        <FilterRadioButton
          onChange={onChangeHandler}
          checked={resolveChecked("reference")}
          value="reference"
          title={t("Number")}
          name="order"
        />
        <FilterRadioButton
          onChange={onChangeHandler}
          checked={resolveChecked("updated_at")}
          value="updated_at"
          title={t("Updated at")}
          name="order"
        />
        <FilterRadioButton
          onChange={onChangeHandler}
          checked={resolveChecked("date_from")}
          value="date_from"
          title={t("ETD")}
          name="order"
        />
        <FilterRadioButton
          onChange={onChangeHandler}
          checked={resolveChecked("date_to")}
          value="date_to"
          title={t("ETA")}
          name="order"
        />
      </div>
    </div>
  );
};
